export const GOOGLE_STATIC_MAPS_URL =
  'https://maps.googleapis.com/maps/api/staticmap';
export const MAP_ZOOM_LEVEL_KEY = 18;
export const BOPIS_MAP_SIZE = {
  XL: '327x261',
  LG: '328x262',
  MD: '328x264',
  SM: '326x261'
};
export const BOPIS_MAP_SIZE_SPLIT_CART = {
  XL: '442x300',
  LG: '671x300',
  MD: '644x300',
  SM: '735x300'
};

export const MARKER_COLOR = '0xf26b1c';